import React,{useState,useCallback,useEffect,useContext,useMemo,useRef} from 'react'
import ReactFlow,{Background,Controls,addEdge,MiniMap,useReactFlow,getRectOfNodes,getTransformForBounds,BackgroundVariant,MarkerType,useNodesState,useEdgesState,updateEdge,ConnectionMode} from 'reactflow';
import 'reactflow/dist/style.css';
import {nanoid} from 'nanoid';
import {useNavigate,useOutletContext,useParams} from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import Loading from '../Loading';
import useChatTabs from '../../hooks/useChatTabs';
import {toPng} from 'html-to-image';
import {storage} from '../../helpers/firebase';
import {ref,uploadString} from 'firebase/storage';
import ErrorContext from '../../contexts/ErrorContext';
import TextNode from '../../components/Nodes/TextNode';
import {NodeProvider} from '../../contexts/NodeContext';
import RectNode from '../../components/Nodes/RectNode'
import HorCylinderNode from '../../components/Nodes/HorCylinderNode'
import RefTrapNode from '../../components/Nodes/RefTrapNode'
import TrapNode from '../../components/Nodes/TrapNode'
import ArrowRectNode from '../../components/Nodes/ArrowRectNode'
import PentNode from '../../components/Nodes/PentNode'
import SquircleNode from '../../components/Nodes/SquircleNode'
import CylinderNode from '../../components/Nodes/CylinderNode'
import CloudNode from '../../components/Nodes/CloudNode'
import CrossNode from '../../components/Nodes/CrossNode'
import DiamondRectNode from '../../components/Nodes/DiamondRectNode'
import SkewRectNode from '../../components/Nodes/SkewRectNode'
import CircleNode from '../../components/Nodes/CircleNode'
import ArrowNode from '../../components/Nodes/ArrowNode'
import RoundedNode from '../../components/Nodes/RoundedNode'
import TriangleNode from '../../components/Nodes/TriangleNode'
import HexNode from '../../components/Nodes/HexNode'
import DNode from '../../components/Nodes/DNode'
import TapeNode from '../../components/Nodes/TapeNode'
import ReccomendationNode from '../../components/Nodes/ReccomendationNode';
import DiamondNode from '../../components/Nodes/DiamondNode'
import ChatPanel from './ChatPanel';
import NodePalette from './NodePalette';
import ProjectSettings from './ProjectSettings';
import CanvasToolbar from './CanvasToolbar';
import {EdgeContextMenu,NodeContextMenu} from './ContextMenus';
import useProject from '../../hooks/useProject';
import {RearrangePreview} from '../../components/Rearrange';
import Input from '../../components/Inputs/Input';
import CreditsContext from '../../contexts/CreditsContext';
import usePageTitle from '../../hooks/usePageTitle';
import useUserSubscription from '../../hooks/useUserSubscription';
import useKeyboardShortcuts from '../../hooks/useKeyboardShortcuts';
import EmbedNode from '../../components/Nodes/EmbedNode';
import YoutubeNode from '../../components/Nodes/Integrations/YoutubeNode';
import LoomNode from '../../components/Nodes/Integrations/LoomNode';
import BoxNode from '../../components/Nodes/Integrations/BoxNode';
import GoogleDocsNode from '../../components/Nodes/Integrations/GoogleDocsNode';
import GoogleSheetsNode from '../../components/Nodes/Integrations/GoogleSheetsNode';
import GoogleSlidesNode from '../../components/Nodes/Integrations/GoogleSlidesNode';
import FigmaNode from '../../components/Nodes/Integrations/FigmaNode';
import GoogleDriveNode from '../../components/Nodes/Integrations/GoogleDriveNode';
import NoteNode from '../../components/Nodes/NoteNode';
import KeyboardShortcutsModal from '../../components/Popups/KeyboardShortcutsModal';
import MermaidImportModal from '../../components/Popups/MermaidImportModal';
import CommandModal from '../../components/Chat/CommandModal'
import {getPlanLimits} from '../../config/planLimits';
import useStreamingAI from '../../hooks/useStreamingAI';
import usePresence from '../../hooks/usePresence';
import {parseMermaid} from '../../helpers/mermaidParser';
import useUndoRedo from '../../hooks/useUndoRedo';
import useVersionHistory from '../../hooks/useVersionHistory';
import useExport from '../../hooks/useExport';
import VersionHistoryPanel from './VersionHistoryPanel';

/** Derive a short, readable tab name from the first user message */
function generateTabName(message) {
    // Strip leading slash command (e.g. "/complete ", "/generate ")
    const stripped=message.replace(/^\/\w+\s*/,'').trim();
    const base=stripped||message.trim();
    // Take first 5 meaningful words, skip filler
    const SKIP=new Set(['a','an','the','in','on','at','to','for','of','and','or','is','it','my','me','please']);
    const words=base.split(/\s+/).filter(w=>w.length>1&&!SKIP.has(w.toLowerCase())).slice(0,5);
    const name=words.join(' ')||base.slice(0,28);
    // Title-case first letter, truncate
    const titled=name.charAt(0).toUpperCase()+name.slice(1);
    return titled.length>32? titled.slice(0,30)+'…':titled;
}

export default function Design({readOnly=false,embed=false}) {
    usePageTitle('Design')

    const {getUserPlan}=useUserSubscription()

    const {projectId}=useParams()
    const navigate=useNavigate()
    const [user]=useContext(UserContext)
    const setError=useContext(ErrorContext)
    const updateCredits=useContext(CreditsContext)[1]
    const [userPlan,setUserPlan]=useState('free')
    const [nodes,setNodes,onNodesChange]=useNodesState([]);
    const [edges,setEdges,onEdgesChange]=useEdgesState([]);
    const [showNodes,setShowNodes]=useState(false)
    const [showSettings,setShowSettings]=useState(false)
    const [showChat,setShowChat]=useState(false)
    const chatInputRef=useRef(null)
    const [reactFlowInstance,setReactFlowInstance]=useState(null);
    const [suggestions,setSuggestions]=useState([])
    const [completionPrompt,setCompletionPrompt]=useState('')
    const [showCompletionPromptInput,setShowCompletionPromptInput]=useState(false)
    const [hasUnapprovedChanges,setHasUnapprovedChanges]=useState(false)
    const [rightClickMenuDetails,setRightClickMenuDetails]=useState({show: false,right: 0,left: 0,top: 0,bottom: 0,selectedNodes: [],selectedEdges: []});
    const [showShortcutsModal,setShowShortcutsModal]=useState(false);
    const [showMermaidImport,setShowMermaidImport]=useState(false);
    const [showCommandModal,setShowCommandModal]=useState(false);
    const [showRearrangePreview,setShowRearrangePreview]=useState(false);
    const [rearrangeData,setRearrangeData]=useState(null);
    const [chatPanelWidth,setChatPanelWidth]=useState(400);
    const isResizingRef=useRef(false);
    const [showVersionHistory,setShowVersionHistory]=useState(false);

    // Use chat tabs for managing multiple chat sessions
    const {
        tabs: chatTabs,
        activeTabId,
        activeTab,
        setActiveTabId,
        addTab,
        removeTab,
        updateActiveTabMessages,
        renameTab,
        loadTabs
    }=useChatTabs();

    // Project save/load/autosave/delete
    const {
        projectLoading,
        gridScale,setGridScale,
        publicAccess,setPublicAccess,
        madeChanges,setMadeChanges,
        handleDelete,
    }=useProject({nodes,edges,setNodes,setEdges,chatTabs,activeTab,loadTabs,readOnly})

    // Use unified AI hook for chat management (using active tab's messages)
    const {
        messages: chats,
        isProcessing: chatLoading,
        pendingChanges,
        currentToolCalls,
        thinkingState,
        streamingMessage,
        sendMessage,
        acceptChanges,
        cancelRequest,
        loadMessages,
        deleteMessage
    }=useStreamingAI();

    // ── Undo / Redo ──────────────────────────────────────────────────────────
    const {pushSnapshot,undo,redo,canUndo,canRedo}=useUndoRedo();

    const handleUndo=useCallback(()=>{
        const state=undo();
        if(state) {setNodes(state.nodes); setEdges(state.edges);}
    },[undo,setNodes,setEdges]);

    const handleRedo=useCallback(()=>{
        const state=redo();
        if(state) {setNodes(state.nodes); setEdges(state.edges);}
    },[redo,setNodes,setEdges]);

    // Push undo snapshot on drag stop (committed move)
    const onNodeDragStop=useCallback(()=>{
        pushSnapshot(nodes,edges);
    },[pushSnapshot,nodes,edges]);

    // Push undo snapshot after connect
    const onConnectWithUndo=useCallback((params)=>{
        if(readOnly) return;
        setEdges(eds=>{const next=addEdge(params,eds); pushSnapshot(nodes,next); return next;});
    },[setEdges,readOnly,nodes,pushSnapshot]);

    // ── Group / Ungroup ──────────────────────────────────────────────────────
    const handleGroup=useCallback(()=>{
        const sel=nodes.filter(n=>n.selected);
        if(sel.length<2) return;
        const gid=nanoid();
        const xs=sel.map(n=>n.position.x); const ys=sel.map(n=>n.position.y);
        const minX=Math.min(...xs)-20; const minY=Math.min(...ys)-20;
        const maxX=Math.max(...xs)+180; const maxY=Math.max(...ys)+140;
        const groupNode={id:gid,type:'rectNode',position:{x:minX,y:minY},style:{width:maxX-minX,height:maxY-minY,zIndex:-1},data:{text:'',color:'gray',isGroup:true},selectable:true,draggable:true};
        const movedNodes=sel.map(n=>({...n,position:{x:n.position.x-minX,y:n.position.y-minY},parentId:gid,extent:'parent'}));
        const others=nodes.filter(n=>!n.selected);
        const next=[groupNode,...others,...movedNodes];
        setNodes(next);
        pushSnapshot(next,edges);
    },[nodes,edges,setNodes,pushSnapshot]);

    const handleUngroup=useCallback(()=>{
        const sel=nodes.filter(n=>n.selected&&n.data?.isGroup);
        if(!sel.length) return;
        const gids=new Set(sel.map(n=>n.id));
        const next=nodes
            .filter(n=>!gids.has(n.id))
            .map(n=>{
                if(!n.parentId||!gids.has(n.parentId)) return n;
                const parent=nodes.find(p=>p.id===n.parentId);
                return {...n,parentId:undefined,extent:undefined,position:{x:n.position.x+(parent?.position.x||0),y:n.position.y+(parent?.position.y||0)}};
            });
        setNodes(next);
        pushSnapshot(next,edges);
    },[nodes,edges,setNodes,pushSnapshot]);

    // ── Version History ──────────────────────────────────────────────────────
    const {versions,saveVersion,restoreVersion,deleteVersion}=useVersionHistory({
        uid: user?.uid,
        projectId,
        nodes,
        edges,
        title: ''
    });

    // ── Export ───────────────────────────────────────────────────────────────
    const {getNodes}=useReactFlow();
    const {exportMermaid,exportJSON,importJSON,exportPNG,exportSVG}=useExport({getNodes,title: 'flowchart'});

    const [chatInput,setChatInput]=useState('');
    const ReactFlowRef=useRef(null);
    const prevActiveTabIdRef=useRef(activeTabId);
    const preChangeSnapshotRef=useRef(null);

    // Initial load of messages
    useEffect(() => {
        if(activeTab?.messages) {
            loadMessages(activeTab.messages);
        }
    },[]);

    // Load active tab's messages into useUnifiedAI when switching tabs
    useEffect(() => {
        // Only load if tab actually changed (not initial mount or same tab)
        if(prevActiveTabIdRef.current!==activeTabId) {
            loadMessages(activeTab.messages);
            prevActiveTabIdRef.current=activeTabId;
        }
    },[activeTabId,activeTab.messages,loadMessages]);

    // Sync messages from useUnifiedAI to active tab (only when AI updates, not on tab switch)
    useEffect(() => {
        if(chats.length>0) {
            updateActiveTabMessages(chats);
        }
    },[chats,updateActiveTabMessages]);

    useEffect(() => {
        getUserPlan().then((plan) => {
            setUserPlan(plan)
        })
        updateCredits()
    },[user?.uid,getUserPlan,updateCredits])

    // Push initial undo snapshot once project is loaded
    useEffect(() => {
        if(!projectLoading&&nodes.length>0) {
            pushSnapshot(nodes,edges)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[projectLoading])

    const {navRef,versionHistoryCallbackRef}=useOutletContext()

    // Register version-history toggle with the parent Navbar
    useEffect(()=>{
        if(versionHistoryCallbackRef) {
            versionHistoryCallbackRef.current=()=>setShowVersionHistory(v=>!v)
        }
        return ()=>{if(versionHistoryCallbackRef) versionHistoryCallbackRef.current=null}
    },[versionHistoryCallbackRef])

    // ── Presence ─────────────────────────────────────────────────────────────
    // ownerUid is the project owner; for shared projects it comes from useParams
    const {uid: ownerUidParam}=useParams()
    const presenceOwnerUid=ownerUidParam||user?.uid
    const {updateSelectedNodes}=usePresence({
        ownerUid: presenceOwnerUid,
        projectId,
        myUid: user?.uid,
        displayName: user?.displayName,
        enabled: !readOnly&&!!user?.uid&&!!projectId
    })

    // Enable keyboard shortcuts
    useKeyboardShortcuts({
        nodes,
        edges,
        setNodes,
        setEdges,
        readOnly,
        onUndo: handleUndo,
        onRedo: handleRedo,
        onGroup: handleGroup,
        onUngroup: handleUngroup,
        disabled: showChat||showSettings||showCompletionPromptInput
    });

    // Handle keyboard shortcuts
    useEffect(() => {
        const handleKeyPress=(e) => {
            // Cmd/Ctrl+K to open command modal or toggle chat
            if((e.metaKey||e.ctrlKey)&&e.key==='k') {
                e.preventDefault();
                if(!showChat) {
                    setShowCommandModal(prev => !prev);
                } else {
                    setShowChat(false);
                }
            }

            // '?' key for shortcuts modal
            if(e.key==='?'&&!e.ctrlKey&&!e.metaKey) {
                const target=e.target;
                if(
                    target.tagName!=='INPUT'&&
                    target.tagName!=='TEXTAREA'&&
                    !target.isContentEditable
                ) {
                    e.preventDefault();
                    setShowShortcutsModal(true);
                }
            }

            // ESC to close modals or chat
            if(e.key==='Escape') {
                if(showShortcutsModal) {
                    setShowShortcutsModal(false);
                } else if(showChat) {
                    setShowChat(false);
                }
            }
        };

        window.addEventListener('keydown',handleKeyPress);
        return () => window.removeEventListener('keydown',handleKeyPress);
    },[showShortcutsModal,showChat]);

    // Chat panel resize handlers (handle on left side, panel on right)
    const handleResizeMouseDown=useCallback((e) => {
        e.preventDefault();
        isResizingRef.current=true;
        document.body.style.cursor='ew-resize';
        document.body.style.userSelect='none';

        const handleMouseMove=(e) => {
            if(!isResizingRef.current) return;
            // Calculate width from right edge of screen to mouse position
            const newWidth=window.innerWidth-e.clientX;
            setChatPanelWidth(Math.max(300,Math.min(800,newWidth)));
        };

        const handleMouseUp=() => {
            isResizingRef.current=false;
            document.body.style.cursor='';
            document.body.style.userSelect='';
            document.removeEventListener('mousemove',handleMouseMove);
            document.removeEventListener('mouseup',handleMouseUp);
        };

        document.addEventListener('mousemove',handleMouseMove);
        document.addEventListener('mouseup',handleMouseUp);
    },[]);

    const onDragOver=useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect='move';
    },[]);

    const onDragStart=(event,nodeType) => {
        event.dataTransfer.setData('application/reactflow',nodeType);
        event.dataTransfer.effectAllowed='move';
    };

    const onEdgeUpdate=useCallback(
        (oldEdge,newConnection) => {return setEdges((els) => updateEdge(oldEdge,newConnection,els))},
        [setEdges]
    );

    const uploadProjectView=useCallback(() => {
        const imageWidth=512;
        const imageHeight=384;
        const nodesBounds=getRectOfNodes(getNodes());
        const transform=getTransformForBounds(nodesBounds,imageWidth,imageHeight,0.5,2);

        const storageRef=ref(storage,`users/${user.uid}/${projectId}/view.png`)

        toPng(document.querySelector('.react-flow__viewport'),{
            backgroundColor: '#d8f3df',
            width: imageWidth,
            height: imageHeight,
            style: {
                width: imageWidth,
                height: imageHeight,
                transform: `translate(${transform[0]}px, ${transform[1]}px) scale(${transform[2]})`,
            },
        }).then(dataUrl => {
            uploadString(storageRef,dataUrl,'data_url')
        })
    },[user,projectId,getNodes])

    const onDrop=useCallback(
        (event) => {
            event.preventDefault();

            const type=event.dataTransfer.getData('application/reactflow');

            if(typeof type==='undefined'||!type) {
                return;
            }

            const position=reactFlowInstance.screenToFlowPosition({
                x: event.clientX,
                y: event.clientY,
            });
            const newNode={
                id: nanoid(),
                type,
                position,
                style: {
                    width: 140
                },
                data: {
                    text: 'Untitled Node',
                }
            };

            setNodes((nds) => nds.concat(newNode));
        },
        [reactFlowInstance,setNodes],
    );

    const onNodeContextMenu=useCallback((event,node) => {
        event.preventDefault();
        const pane=ReactFlowRef.current.getBoundingClientRect();
        setRightClickMenuDetails(rightClickMenuDetails => ({
            show: true,
            top: event.clientY<pane.height-300&&event.clientY-100,
            left: event.clientX<pane.width&&event.clientX,
            right: event.clientX>=pane.width&&pane.width-event.clientX,
            bottom: event.clientY>=pane.height-300&&pane.height-event.clientY+100,
            selectedNodes: [node.id],
        }));
    }
        ,[setRightClickMenuDetails]);

    const onEdgeContextMenu=useCallback((event,edge) => {
        event.preventDefault();
        const pane=ReactFlowRef.current.getBoundingClientRect();
        setRightClickMenuDetails(rightClickMenuDetails => ({
            show: true,
            top: event.clientY<pane.height-200&&event.clientY-100,
            left: event.clientX<pane.width&&event.clientX,
            right: event.clientX>=pane.width&&pane.width-event.clientX,
            bottom: event.clientY>=pane.height-200&&pane.height-event.clientY+100,
            selectedEdges: [edge.id],
        }));
    },[setRightClickMenuDetails]);

    // Presence-based selection tracking — does NOT store anything in node/edge data
    const onSelectionChange=useCallback((changes) => {
        const selectedNodeIds=changes.nodes.map(n=>n.id);
        updateSelectedNodes(selectedNodeIds);
    },[updateSelectedNodes]);

    const onPaneClick=useCallback(() => setRightClickMenuDetails(rightClickMenuDetails => {
        if(!madeChanges) {
            uploadProjectView();
        }
        setMadeChanges(true)

        if(rightClickMenuDetails.show) {
            return {
                ...rightClickMenuDetails,
                show: false,
            };
        }
        return rightClickMenuDetails;
    }),[setRightClickMenuDetails,madeChanges,setMadeChanges,uploadProjectView]);

    // Unified AI handler - now uses useUnifiedAI hook
    const handleUnifiedAI=async (e) => {
        if(e) {
            e.preventDefault()
        }
        if(chatLoading) return
        if(chatInput.length<=0) return

        const currentMessage=chatInput

        // /mermaid — parse and apply client-side, no AI call needed
        if(currentMessage.trimStart().startsWith('/mermaid')) {
            const mermaidSyntax=currentMessage.replace(/^\/mermaid\s*/,'').trim()
            if(mermaidSyntax) {
                setChatInput('')
                try {
                    const result=parseMermaid(mermaidSyntax,{existingNodes: nodes})
                    if(result.nodes?.length>0) {
                        const offsetY=nodes.length>0? Math.max(...nodes.map(n=>(n.position?.y||0)+150))+80:0
                        const offsetNodes=result.nodes.map(n=>({...n,position:{x:n.position?.x||0,y:(n.position?.y||0)+offsetY}}))
                        setNodes(prev=>[...prev,...offsetNodes])
                        setEdges(prev=>[...prev,...(result.edges||[])])
                        pushSnapshot([...nodes,...offsetNodes],[...edges,...(result.edges||[])])
                    }
                } catch {
                    setError('Could not parse Mermaid syntax. Please check your diagram code.')
                }
                return
            }
        }

        // Get selected nodes for context
        const selectedNodes=nodes.filter(n => n.selected)

        try {
            // Clear input immediately for better UX
            setChatInput('')

            // Use the hook's sendMessage with context
            await sendMessage(currentMessage,{
                nodes,
                edges,
                selectedNodes,
                onSuccess: (data) => {
                    // Snapshot current state before applying so Reject can restore
                    preChangeSnapshotRef.current={nodes: [...nodes],edges: [...edges]}
                    // Apply changes to canvas immediately as preview (approved: false)
                    // User sees them, then Accept confirms or Reject removes
                    if(data.changes) {
                        requestAnimationFrame(() => applyChangesToFlowchart(data.changes))
                    }
                },
                onError: (error) => {
                    if(error.code==='functions/resource-exhausted') {
                        navigate('/pricing')
                    }
                    // Restore input on error so user can retry
                    setChatInput(currentMessage)
                }
            })

            // Auto-name tab from first user message if tab is "Untitled"
            if(activeTab.name==='Untitled'&&currentMessage.trim()) {
                renameTab(activeTabId,generateTabName(currentMessage));
            }
        } catch(error) {
            console.error('AI chat error:',error)
            // Restore input on error
            setChatInput(currentMessage)
        }
    }

    // Helper to apply AI changes to flowchart state
    const applyChangesToFlowchart=useCallback((changes) => {
        if(!changes) return

        // Handle rearrange - show preview modal instead of applying immediately
        if(changes.newPositions?.length>0&&!changes.nodesToAdd&&!changes.nodesToModify) {
            setRearrangeData({
                originalNodes: nodes,
                newPositions: changes.newPositions,
                updatedEdges: changes.updatedEdges,
                layout: changes.layout||'hierarchical'
            })
            setShowRearrangePreview(true)
            return // Don't apply changes yet, wait for user approval
        }

        // Add new nodes
        if(changes.nodesToAdd?.length>0) {
            const newNodes=changes.nodesToAdd.map(node => ({
                ...node,
                position: {
                    x: node.position?.x??0,
                    y: node.position?.y??0
                },
                data: {...node.data,approved: false,diffType: 'add'}
            }))
            setNodes(currentNodes => [...currentNodes,...newNodes])
        }

        // Add new edges
        if(changes.edgesToAdd?.length>0) {
            setEdges(currentEdges => {
                const existingIds=new Set(currentEdges.map(e => e.id))
                const newEdges=changes.edgesToAdd.filter(e => !existingIds.has(e.id))
                return [...currentEdges,...newEdges]
            })
        }

        // Modify nodes
        if(changes.nodesToModify?.length>0) {
            setNodes(currentNodes => currentNodes.map(node => {
                const modification=changes.nodesToModify.find(m => m.id===node.id)
                if(modification) {
                    return {
                        ...node,
                        ...(modification.changes.type&&{type: modification.changes.type}),
                        ...(modification.changes.position&&{position: modification.changes.position}),
                        data: {
                            ...node.data,
                            ...(modification.changes.text&&{text: modification.changes.text}),
                            approved: false,
                            diffType: 'modify'
                        }
                    }
                }
                return node
            }))
        }

        // Delete nodes and edges
        if(changes.nodesToDelete?.length>0) {
            setNodes(currentNodes => currentNodes.filter(n => !changes.nodesToDelete.includes(n.id)))
            setEdges(currentEdges => currentEdges.filter(e =>
                !changes.nodesToDelete.includes(e.source)&&!changes.nodesToDelete.includes(e.target)
            ))
        }
        if(changes.edgesToDelete?.length>0) {
            setEdges(currentEdges => currentEdges.filter(e => !changes.edgesToDelete.includes(e.id)))
        }

        // Apply new positions (if not showing preview)
        if(changes.newPositions?.length>0&&!showRearrangePreview) {
            setNodes(currentNodes => currentNodes.map(node => {
                const newPos=changes.newPositions.find(p => p.id===node.id)
                return newPos? {...node,position: newPos.position}:node
            }))
        }

        // Apply updated edges
        if(changes.updatedEdges?.length>0) {
            setEdges(changes.updatedEdges)
        }

        // Show suggestions
        if(changes.suggestions?.length>0) {
            const sortedSuggestions=[...changes.suggestions].sort((a,b) => b.score-a.score).slice(0,3)
            setSuggestions(sortedSuggestions)
        }
    },[setNodes,setEdges,nodes,showRearrangePreview])


    // Accept: if filteredChanges provided (partial), restore snapshot and re-apply only selected
    const handleAcceptChanges=useCallback((filteredChanges) => {
        if(filteredChanges&&preChangeSnapshotRef.current) {
            // Restore to pre-change state first
            const snapNodes=preChangeSnapshotRef.current.nodes;
            const snapEdges=preChangeSnapshotRef.current.edges;

            // Re-apply only selected additions
            let resultNodes=[...snapNodes];
            let resultEdges=[...snapEdges];

            if(filteredChanges.nodesToAdd?.length>0) {
                const newNodes=filteredChanges.nodesToAdd.map(n => ({
                    ...n,
                    position: {x: n.position?.x??0,y: n.position?.y??0},
                    data: {...n.data,approved: true}
                }));
                resultNodes=[...resultNodes,...newNodes];
            }
            if(filteredChanges.nodesToModify?.length>0) {
                resultNodes=resultNodes.map(node => {
                    const mod=filteredChanges.nodesToModify.find(m => m.id===node.id);
                    if(mod) {
                        return {
                            ...node,
                            ...(mod.changes.type&&{type: mod.changes.type}),
                            ...(mod.changes.position&&{position: mod.changes.position}),
                            data: {...node.data,...(mod.changes.text&&{text: mod.changes.text}),approved: true}
                        };
                    }
                    return node;
                });
            }
            if(filteredChanges.nodesToDelete?.length>0) {
                resultNodes=resultNodes.filter(n => !filteredChanges.nodesToDelete.includes(n.id));
                resultEdges=resultEdges.filter(e =>
                    !filteredChanges.nodesToDelete.includes(e.source)&&!filteredChanges.nodesToDelete.includes(e.target)
                );
            }
            if(filteredChanges.edgesToAdd?.length>0) {
                const existingIds=new Set(resultEdges.map(e => e.id));
                const newEdges=filteredChanges.edgesToAdd.filter(e => !existingIds.has(e.id));
                resultEdges=[...resultEdges,...newEdges];
            }
            if(filteredChanges.edgesToDelete?.length>0) {
                resultEdges=resultEdges.filter(e => !filteredChanges.edgesToDelete.includes(e.id));
            }
            if(filteredChanges.newPositions?.length>0) {
                resultNodes=resultNodes.map(node => {
                    const newPos=filteredChanges.newPositions.find(p => p.id===node.id);
                    return newPos? {...node,position: newPos.position}:node;
                });
            }

            setNodes(resultNodes);
            setEdges(resultEdges);
        } else {
            // Accept all (legacy path) — clear diffType markers
            setNodes(prev => prev.map(node => {
                if(typeof node.data.approved==='boolean'&&!node.data.approved) {
                    const {diffType,...cleanData}=node.data;
                    return {...node,data: {...cleanData,approved: true}}
                }
                return node
            }))
        }
        preChangeSnapshotRef.current=null
        acceptChanges()
        // Push accepted state to undo stack so the AI change can be undone
        pushSnapshot(nodes,edges)
    },[setNodes,setEdges,acceptChanges,pushSnapshot,nodes,edges])

    // Reject: restore pre-change snapshot (reverts adds, modifications, and deletions)
    const handleRejectChanges=useCallback(() => {
        if(preChangeSnapshotRef.current) {
            setNodes(preChangeSnapshotRef.current.nodes)
            setEdges(preChangeSnapshotRef.current.edges)
            preChangeSnapshotRef.current=null
        }
        acceptChanges() // clears pendingChanges
    },[setNodes,setEdges,acceptChanges])

    // addNewElements removed - Sprint 1.5 agentic chat handles adding elements directly

    useEffect(() => {
        const unapprovedNodes=nodes.filter(node => typeof node.data.approved==='boolean'&&!node.data.approved)
        setHasUnapprovedChanges(unapprovedNodes.length>0)
    },[nodes])

    // Page title is now set by usePageTitle hook directly

    useEffect(() => {
        if(!projectLoading&&suggestions.length>0) {
            // Copy suggestions to process and immediately clear state
            const suggestionsToProcess=[...suggestions]
            setSuggestions([])

            setNodes(currentNodes => {
                const reccNodes=suggestionsToProcess.map((suggestion) => {
                    return {
                        id: nanoid(),
                        type: 'reccNode',
                        // Use position from API (placed near relevant nodes)
                        position: {
                            x: suggestion.position?.x||100,
                            y: suggestion.position?.y||100
                        },
                        style: {
                            width: 192 // w-48 = 12rem = 192px
                        },
                        data: {
                            text: suggestion.suggestion,
                            score: suggestion.score
                        }
                    }
                })
                return [...currentNodes,...reccNodes]
            })
        }
    },[projectLoading,suggestions,setNodes])

    // Handle completion prompt input via chat
    useEffect(() => {
        if(!projectLoading) {
            if(showCompletionPromptInput) {
                document.onkeyup=function(e) {
                    if(e.key==='Enter'&&completionPrompt.trim()) {
                        // Use unified AI with completion prefix
                        setChatInput('/complete '+completionPrompt)
                        setShowCompletionPromptInput(false)
                        setCompletionPrompt('')
                        setShowChat(true)
                    }
                    if(e.key==='Escape') {
                        setShowCompletionPromptInput(false)
                    }
                }
            } else {
                document.onkeyup=null
            }
        }
    },[projectLoading,showCompletionPromptInput,completionPrompt])


    const nodeTypes=useMemo(() => ({
        textNode: TextNode,
        rectNode: RectNode,
        horCylinderNode: HorCylinderNode,
        refTrapNode: RefTrapNode,
        trapNode: TrapNode,
        arrowRectNode: ArrowRectNode,
        pentNode: PentNode,
        squircleNode: SquircleNode,
        cylinderNode: CylinderNode,
        cloudNode: CloudNode,
        crossNode: CrossNode,
        diamondRectNode: DiamondRectNode,
        skewRectNode: SkewRectNode,
        circleNode: CircleNode,
        arrowNode: ArrowNode,
        roundedNode: RoundedNode,
        triangleNode: TriangleNode,
        hexNode: HexNode,
        dNode: DNode,
        tapeNode: TapeNode,
        diamondNode: DiamondNode,
        reccNode: ReccomendationNode,
        embedNode: EmbedNode,
        youtubeNode: YoutubeNode,
        figmaNode: FigmaNode,
        loomNode: LoomNode,
        boxNode: BoxNode,
        googleDriveNode: GoogleDriveNode,
        googleDocsNode: GoogleDocsNode,
        googleSheetsNode: GoogleSheetsNode,
        googleSlidesNode: GoogleSlidesNode,
        noteNode: NoteNode
    }),[]);

    const proOptions={
        hideAttribution: true,
    }

    if(projectLoading) {
        return <Loading />
    }

    // 5.4.3 — Desktop-only guard: show friendly message on mobile
    if(!embed&&window.innerWidth<768) {
        return (
            <div className='flex flex-col items-center justify-center h-screen gap-6 p-8 text-center bg-light'>
                <div className='text-5xl'>💻</div>
                <h2 className='text-xl font-bold text-dark'>Desktop required</h2>
                <p className='text-sm text-dark-400 max-w-xs'>The flowchart canvas is designed for desktop use. Please open Flowsage on a larger screen to edit your diagram.</p>
                <a href='/dashboard' className='px-4 py-2 text-sm font-semibold text-white rounded-lg bg-primary hover:bg-primary-600 transition-colors'>Back to Dashboard</a>
            </div>
        )
    }


    // const connectingNodeId=useRef(null);
    // const onConnectStart=useCallback((_,{nodeId}) => {
    //     connectingNodeId.current=nodeId;
    // },[]);


    // const onConnectEnd=useCallback((event) => {
    //     const targetIsPane=(event.target).classList.contains(
    //         'react-flow__pane',
    //     );
    // },[]);

    const setNodeValue=(id,value,path='data.text') => {
        if(readOnly) {
            return
        }
        if(typeof value=='string'&&value.length>250) {
            setError('Sorry, it looks like the text you entered is too long.')
            return
        }
        setNodes((nodes) => nodes.map((node) => {
            if(node.id===id) {
                const pathParts=path.split('.');
                const setNested=(obj,parts,val) => {
                    if(parts.length===1) {
                        return {...obj,[parts[0]]: val}
                    }
                    return {...obj,[parts[0]]: setNested(obj[parts[0]]||{},parts.slice(1),val)}
                }
                return setNested(node,pathParts,value)
            }
            return node;
        }))
    }

    const deleteNode=(id) => {
        if(readOnly) {
            return
        }
        setNodes((nodes) => nodes.filter((node) => node.id!==id))
        setEdges((edges) => edges.filter((edge) => edge.source!==id&&edge.target!==id))
    }

    const addNode=(type) => {
        const limits=getPlanLimits(userPlan)
        if(limits.nodesPerProject!==Infinity&&nodes.length>=limits.nodesPerProject) {
            setError('Sorry, it looks like you have reached the maximum number of nodes allowed on your plan. Please upgrade your plan to continue using this feature.')
            navigate('/pricing')
            return
        }
        setNodes(nodes => [...nodes,{
            id: nanoid(),
            position: {x: 0,y: 0},
            style: {
                width: 140
            },
            type: type,
            data: {
                text: 'Untitled Node',
            },
        },])
    }

    const getNodeValue=(id,value='text') => {
        const node=nodes.find((node) => node.id===id);
        if(!node||!node.data) {
            return null
        }
        return typeof node?.data[value]==='undefined'? null:node?.data[value];
    }



    return (
        <div style={{height: `calc(100vh - ${window.getComputedStyle(navRef.current).height})`}} className='flex overflow-hidden relative flex-row w-full'>
            {(rightClickMenuDetails.show&&rightClickMenuDetails.selectedEdges?.length>0&&!readOnly)&&<EdgeContextMenu
                menuDetails={rightClickMenuDetails}
                setEdges={setEdges}
                setRightClickMenuDetails={setRightClickMenuDetails}
            />}
            {(rightClickMenuDetails.show&&rightClickMenuDetails.selectedNodes?.length>0&&!readOnly)&&<NodeContextMenu
                menuDetails={rightClickMenuDetails}
                nodes={nodes}
                setNodes={setNodes}
                setEdges={setEdges}
                setRightClickMenuDetails={setRightClickMenuDetails}
                onDuplicate={()=>{
                    const sel=nodes.filter(n=>rightClickMenuDetails.selectedNodes.includes(n.id));
                    const selectedIds=new Set(sel.map(n=>n.id));
                    const internalEdges=edges.filter(e=>selectedIds.has(e.source)&&selectedIds.has(e.target));
                    const idMap={};
                    const newNodes=sel.map(n=>{const nid=nanoid();idMap[n.id]=nid;return{...n,id:nid,position:{x:n.position.x+50,y:n.position.y+50},selected:false,data:{...n.data,approved:true}};});
                    const newEdges=internalEdges.map(e=>({...e,id:nanoid(),source:idMap[e.source]||e.source,target:idMap[e.target]||e.target}));
                    setNodes(ns=>[...ns,...newNodes]);
                    setEdges(es=>[...es,...newEdges]);
                    pushSnapshot([...nodes,...newNodes],[...edges,...newEdges]);
                }}
                onCopy={async ()=>{
                    const sel=nodes.filter(n=>rightClickMenuDetails.selectedNodes.includes(n.id));
                    const selectedIds=new Set(sel.map(n=>n.id));
                    const internalEdges=edges.filter(e=>selectedIds.has(e.source)&&selectedIds.has(e.target));
                    const payload=JSON.stringify({__flowsage:true,nodes:sel,edges:internalEdges});
                    try{await navigator.clipboard.writeText(payload);}catch{localStorage.setItem('flowsage_clipboard',payload);}
                }}
            />}
            {showNodes&&<NodePalette
                onClose={() => setShowNodes(false)}
                onDragStart={onDragStart}
                addNode={addNode}
            />}
            {showVersionHistory&&<VersionHistoryPanel
                versions={versions}
                onSaveVersion={saveVersion}
                onRestoreVersion={(id)=>restoreVersion(id,{setNodes,setTitle:()=>{}})}
                onDeleteVersion={deleteVersion}
                onClose={()=>setShowVersionHistory(false)}
            />}
            <div className={`w-full`} style={{height: `calc(100vh - ${window.getComputedStyle(navRef.current).height})`}}>
                <NodeProvider value={[setNodeValue,getNodeValue,deleteNode]}>
                    <ReactFlow ref={ReactFlowRef} onInit={(reactflow) => {setReactFlowInstance(reactflow)}} nodeTypes={nodeTypes} proOptions={proOptions} fitView defaultViewport={{x: 0,y: 0,zoom: 1.5}} nodes={nodes} edges={edges} onNodesChange={onNodesChange} onDrop={onDrop} onDragOver={onDragOver} onEdgesChange={onEdgesChange} onConnect={onConnectWithUndo} onNodeDragStop={onNodeDragStop} snapGrid={[gridScale,gridScale]} snapToGrid={gridScale>0} onEdgeContextMenu={onEdgeContextMenu} selectionOnDrag={true} panOnDrag={true} panOnScroll={false} selectionMode='partial' selectionKeyCode='Shift' multiSelectionKeyCode='Control' deleteKeyCode={['Delete','Backspace']} elementsSelectable={!readOnly} nodesDraggable={!readOnly} nodesConnectable={!readOnly} edgesUpdatable={!readOnly} connectionMode={ConnectionMode.Loose} onPaneClick={onPaneClick} nodesFocusable={!readOnly} onNodeContextMenu={onNodeContextMenu} onEdgeUpdate={onEdgeUpdate} onSelectionChange={onSelectionChange} defaultEdgeOptions={{
                        markerStart: {
                            type: MarkerType.ArrowClosed,color: 'rgba(0,0,0,0)'
                        },markerEnd: {
                            type: MarkerType.ArrowClosed,color: 'rgba(0,0,0,0)'
                        }
                    }}>
                        <Background variant={BackgroundVariant.Dots} gap={10} />
                        <Controls />
                        {!readOnly&&<CanvasToolbar
                            chatLoading={chatLoading}
                            hasUnapprovedChanges={hasUnapprovedChanges}
                            canUndo={canUndo}
                            canRedo={canRedo}
                            onUndo={handleUndo}
                            onRedo={handleRedo}
onToggleChat={() => {setShowChat((showChat) => !showChat); setShowSettings(false)}}
                            onToggleSettings={() => {setShowSettings((showSettings) => !showSettings); setShowChat(false)}}
                            onToggleNodes={() => setShowNodes((showNodes) => !showNodes)}
                            onOpenMermaidImport={() => setShowMermaidImport(true)}
                            onOpenShortcuts={() => setShowShortcutsModal(true)}
                            onExportPNG={(scale)=>exportPNG(scale)}
                            onExportSVG={exportSVG}
                            onExportMermaid={()=>exportMermaid(nodes,edges)}
                            onExportJSON={()=>exportJSON(nodes,edges)}
                            onImportJSON={(file)=>importJSON(file,{setNodes,setEdges})}
                            onAcceptAllChanges={() => {
                                setNodes(nodes => nodes.map(node => {
                                    if(typeof node.data.approved==='boolean'&&!node.data.approved) {
                                        const {diffType,...cleanData}=node.data;
                                        return {...node,data:{...cleanData,approved:true}}
                                    }
                                    return node
                                }))
                                pushSnapshot(nodes,edges)
                            }}
                            onRejectAllChanges={() => {
                                setNodes(nodes => nodes.filter(node => typeof node.data.approved==='boolean'? node.data.approved:true))
                            }}
                        />}
                        <MiniMap nodeStrokeWidth={3} zoomable pannable />
                    </ReactFlow>
                </NodeProvider>
                {showCompletionPromptInput&&<div className='flex absolute z-50 flex-col justify-center items-center p-3 text-xl rounded-md border shadow-md bg-light' style={{top: '80px',right: '20px',boxSizing: 'border-box'}}>
                    <Input className='!w-full' style={{width: '100%',boxSizing: 'border-box'}} value={completionPrompt} onChange={(e) => setCompletionPrompt(e.target.value)} placeholder='Describe the flowchart you want...' detailsClassName='text-dark' details='Press Esc to close. Press Enter to generate.' />
                </div>}
            </div>
            {
                showSettings&&<ProjectSettings
                    onClose={() => setShowSettings(false)}
                    gridScale={gridScale}
                    setGridScale={setGridScale}
                    publicAccess={publicAccess}
                    setPublicAccess={setPublicAccess}
                    onDelete={handleDelete}
                />
            }
            {
                showChat&&<ChatPanel
                    width={chatPanelWidth}
                    height={`calc(100vh - ${window.getComputedStyle(navRef.current).height})`}
                    onResizeMouseDown={handleResizeMouseDown}
                    onClose={() => setShowChat(false)}
                    chatTabs={chatTabs}
                    activeTabId={activeTabId}
                    onTabChange={setActiveTabId}
                    onAddTab={addTab}
                    onRemoveTab={removeTab}
                    chats={chats}
                    onDeleteBubble={(index) => {
                        deleteMessage(index);
                        const newMessages=chats.filter((_,i) => i!==index);
                        updateActiveTabMessages(newMessages);
                    }}
                    chatLoading={chatLoading}
                    currentToolCalls={currentToolCalls}
                    thinkingState={thinkingState}
                    streamingMessage={streamingMessage}
                    pendingChanges={pendingChanges}
                    currentNodes={nodes}
                    onAcceptChanges={handleAcceptChanges}
                    onRejectChanges={handleRejectChanges}
                    chatInput={chatInput}
                    onChatInputChange={setChatInput}
                    onSubmit={handleUnifiedAI}
                    onCancel={cancelRequest}
                    userName={user?.displayName?.split(' ')[0]}
                />
            }
            <CommandModal
                isOpen={showCommandModal}
                onClose={() => setShowCommandModal(false)}
                onSelect={(command) => {
                    setShowCommandModal(false);
                    setShowChat(true);
                    setChatInput(command);
                    setShowSettings(false);
                }}
            />
            <KeyboardShortcutsModal
                isOpen={showShortcutsModal}
                onClose={() => setShowShortcutsModal(false)}
            />
            <MermaidImportModal
                isOpen={showMermaidImport}
                onClose={() => setShowMermaidImport(false)}
                onImport={(result) => {
                    setNodes(prev => {
                        // Offset imported nodes to avoid overlapping existing ones
                        let offsetX=0,offsetY=0;
                        if(prev.length>0) {
                            const maxY=Math.max(...prev.map(n => (n.position?.y||0)+150));
                            const avgX=prev.reduce((s,n) => s+(n.position?.x||0),0)/prev.length;
                            const importAvgX=result.nodes.length>0
                                ? result.nodes.reduce((s,n) => s+(n.position?.x||0),0)/result.nodes.length
                                :0;
                            offsetY=maxY+80;
                            offsetX=avgX-importAvgX;
                        }
                        const offsetNodes=result.nodes.map(n => ({
                            ...n,
                            position: {x: (n.position?.x||0)+offsetX,y: (n.position?.y||0)+offsetY}
                        }));
                        return [...prev,...offsetNodes];
                    });
                    setEdges(prev => [...prev,...result.edges]);
                }}
            />
            {showRearrangePreview&&rearrangeData&&(
                <RearrangePreview
                    originalNodes={rearrangeData.originalNodes}
                    newPositions={rearrangeData.newPositions}
                    layout={rearrangeData.layout}
                    onApply={() => {
                        // Apply the rearrange changes
                        setNodes(currentNodes => currentNodes.map(node => {
                            const newPos=rearrangeData.newPositions.find(p => p.id===node.id)
                            return newPos? {...node,position: newPos.position}:node
                        }))
                        if(rearrangeData.updatedEdges) {
                            setEdges(rearrangeData.updatedEdges)
                        }
                        setShowRearrangePreview(false)
                        setRearrangeData(null)
                    }}
                    onReject={() => {
                        setShowRearrangePreview(false)
                        setRearrangeData(null)
                    }}
                />
            )}
        </div>
    )
}
